import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
export const BuildingDisposition = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Frente' },
    { value: 2, label: 'Contrafrente' },
    { value: 3, label: 'Interno' },
    { value: 4, label: 'Lateral' }
  ];
  return (
    <div>
      <label>Disposición de la propiedad</label>
      <ReactSelect
        name="buildingDisposition"
        placeholder="-- Seleccione la Disposición --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj(
            'buildingDisposition',
            e?.value && Number(e.value)
          );
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingDisposition.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
